import { VegaMark } from '@/components/VegaMark';
import { AuthGate } from './AuthGate';

/**
 * Tela de login (não autenticado). Marca Vega + SSO Entra (via AuthGate).
 * Mostrada pela rota raiz quando não há sessão.
 */
export function LoginScreen() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-background text-foreground">
      <div className="w-full max-w-sm space-y-6 rounded-lg border border-border bg-card p-8 text-center shadow-sm">
        <div className="flex flex-col items-center gap-3">
          <VegaMark className="h-9 w-9 text-foreground" />
          <h1 className="font-sans text-2xl font-semibold tracking-tight">Portal Vega</h1>
          <p className="text-sm text-muted-foreground">CRM de deal flow da Vega Asset</p>
        </div>
        <AuthGate />
      </div>
    </main>
  );
}
